export const SEARCH_TERM_CHANGED = 'SEARCH_TERM_CHANGED';
